/*
 * @Author: bianbinbin
 * @Date: 2024-04-11 14:23:50
 * @LastEditors: bianbinbin
 * @LastEditTime: 2024-04-11 14:25:29
 * @PageTitle: 页面...
 * @Description: 描述...
 * @FilePath: /ejx-web/src/router/module/crewMealSelection.js
 */
const crewMealSelection = r =>
  require.ensure([], () => r(require('@/views/crewMealSelection/crewMealSelection.vue'), 'crewMealSelection'))

const router = [
  {
    path: '/crewMealSelection',
    name: 'crewMealSelection',
    meta: {
      title: '机组选餐'
    },
    component: crewMealSelection
  }
]

export default router
